<template>
  <div>
    <div id="search">
      <el-row style="height: 40px">
        <span style="font-size: 14px">商品修改时间</span>

        <el-date-picker
          style="" size="small"
          :default-time="['00:00:00', '23:59:59']"
          v-model="tradeDate"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right">
        </el-date-picker>

        <el-button type="primary" size="small" @click="startItem">同步商品信息</el-button>
        <el-button plain type="primary" size="small" @click="gotoSku" style="margin-right: 20px; margin-left: 20px">SKU信息</el-button>
        <el-input v-model="title" size="small" style="width: 200px"></el-input>
        <el-button type="primary" size="small"  @click="getItemData" >搜索</el-button>
      </el-row>
      <div class="block" align="center">
        <span class="demonstration"></span>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageObject.pageCurrent"
          :page-sizes="[20, 50, 100, 500, 1000, 2000]"
          :page-size="pageObject.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageObject.rowCount">
        </el-pagination>
      </div>
    </div>

    <el-button type="primary" size="mini" @click="hide">全屏显示/恢复</el-button>
    <el-row>
      <el-col :span="24">
        <el-table border style="font-size: 12px"  :data="itemData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">


          <el-table-column  prop="approveStatus" label="approveStatus" width="120px"></el-table-column>\
          <el-table-column  prop="numIid" label="numIid" width="120px"></el-table-column>
          <el-table-column  prop="title" label="title" width="380px"></el-table-column>
          <el-table-column  prop="cid" label="cid" width="120px"></el-table-column>
          <el-table-column  prop="type" label="type" width="100px"></el-table-column>
          <el-table-column  prop="picUrl" label="picUrl" width="600px"></el-table-column>
          <el-table-column  prop="num" label="num" width="120px"></el-table-column>
          <el-table-column  prop="props" label="props" width="1000px"></el-table-column>
          <el-table-column  prop="validThru" label="validThru" width="120px"></el-table-column>
          <el-table-column  prop="listTime" label="listTime" width="160px"></el-table-column>
          <el-table-column  prop="price" label="price" width="120px"></el-table-column>
          <el-table-column  prop="hasDiscount" label="hasDiscount" width="120px"></el-table-column>
          <el-table-column  prop="hasInvoice" label="hasInvoice" width="120px"></el-table-column>
          <el-table-column  prop="hasWarranty" label="hasWarranty" width="120px"></el-table-column>
          <el-table-column  prop="hasShowcase" label="hasShowcase" width="120px"></el-table-column>
          <el-table-column  prop="modified" label="modified" width="160px"></el-table-column>
          <el-table-column  prop="delistTime" label="delistTime" width="160px"></el-table-column>
          <el-table-column  prop="postageId" label="postageId" width="120px"></el-table-column>
          <el-table-column  prop="sellerCids" label="sellerCids" width="120px"></el-table-column>
          <el-table-column  prop="outerId" label="outerId" width="120px"></el-table-column>

          <el-table-column  prop="soldQuantity" label="sold_quantity" width="120px"></el-table-column>
          <el-table-column  prop="propImgsStr" label="prop_imgs" width="2000px"></el-table-column>

        </el-table>
      </el-col>
    </el-row>


  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import datefmt from "../api/date"

  export default {
    name: "ItmFull",
    data(){
      return{
        title:'',
        deny:0,
        display:1,
        itemData:[],
        pageObject: {
          pageCurrent: 1,
          rowCount: 0,
          pageSize: 100
        },

        timer:null,
        funName:'',
        cnName:'',
        //同步完成后提示
        msg:"",
        tradeDate:[],
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();

              let year2, month2, day2
              [year2, month2, day2] = [end.getFullYear(), end.getMonth(), end.getDate()]
              let start = new Date(year2, month2, day2, 0)
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    methods:{
      hide:function(){
        this.display++;
        if(this.display % 2 == 0){
          window.document.getElementById("left").style.display = 'none';
          window.document.getElementById("top").style.display = 'none';
          window.document.getElementById("search").style.display = 'none';
        }else {
          window.document.getElementById("left").style.display = 'block';
          window.document.getElementById("top").style.display = 'block';
          window.document.getElementById("search").style.display = 'block';
        }

      },
      //改变pageSize
      handleSizeChange: function (val) {
        this.pageObject.pageSize = val;
        this.getItemData();
      },
      //当前页面改变
      handleCurrentChange: function (val) {
        this.pageObject.pageCurrent = val;
        this.getItemData();
      },
      getItemData:function () {
        let param={
          nick: storage.get("nick"),
          title:this.title,
          pageCurrent: this.pageObject.pageCurrent,
          rowCount: this.pageObject.rowCount,
          pageSize: this.pageObject.pageSize,
        }
        $api.post("/item/getItmFull", param, response =>{
          let dataResult =  response.data;
          console.log(dataResult);
          if(dataResult.state == 1 && dataResult.message == "ok"){
            this.itemData = dataResult.data.item;

            let pageObject = dataResult.data.pageObject;
            this.pageObject.rowCount = pageObject.rowCount;
            this.pageObject.pageSize = pageObject.pageSize;

          }else{
            this.$message.error(dataResult.message);
            this.$router.replace({name: "Index"});
          }

        })
      },

      //轮询同步状态
      getStatus:function () {
        this.msg='';
        let param={
          nick:storage.get("nick"),
          subNick:storage.get("subnick"),
          funName:this.funName,
          status:"1",
        }
        $api.post("/trade/getStatus", param, response =>{
          let dataResult =  response.data;
          if(dataResult.data == "success") {
            this.getItemData();
            clearTimeout(this.timer);
            this.$message.success("【"+this.cnName +"】数据同步完成。");
            this.msg="【"+this.cnName +"】数据同步完成。";
          }
          else {
            this.timer = setTimeout(this.getStatus, 3000);
            this.msg='running';
            this.$message.warning("【"+this.cnName +"】数据同步中.....");
          }

        })
      },

      startItem:function() {
        if(this.deny == 1){
          console.log(this.deny);
          this.$message.error("您没有该权限, 请联系主号分配权限。");
          return;
        }
        this.$confirm('即将开始从淘宝获取数据，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
          this.getTbItem();
        })
      },

      getTbItem :function(){
        this.funName="GetItems";
        this.cnName=" 商品 ";
        let param ={
          nick: storage.get("nick"),
          subNick:storage.get("subnick"),
          startDate: this.tradeDate[0],
          endDate: this.tradeDate[1],
          allItem:'all',
        }
        $api.post("/item/getTbItem", param , response =>{
          let dataResult =  response.data;
          if(dataResult.state == 1 && dataResult.message == 'ok'){

            this.timer = setTimeout(this.getStatus, 1000);

          }else{
            this.$message.error(dataResult);
          }
        })
      },
      gotoSku:function(){
        if(this.deny == 1){
          this.$message.error("您没有该权限, 请联系主号分配权限。");
          return;
        }
        this.$router.replace({name: 'SkuFull'});
      },
      updateMemo:function (index, row) {
        let param ={
          nick:storage.get("nick"),
          numIid: row.numIid,
          shortName: row.shortName,
          cost:row.cost,
        };
        $api.post("/item/updateItemShortName", param, response => {
          let dataResult = response.data;

          if (dataResult.state == 1 && dataResult.message == "ok") {
            this.$message({
              type: 'success',
              message: '恭喜，设置简称成本价成功！'
            });
          }else {
            this.$message.error(dataResult);
          }
        })
      },
    },
    mounted(){
      this.getItemData();
      //当前设定的日期时间
      let d = new Date
      let year1, month1, day1;
      [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()]
      let date1 = new Date(year1, month1, day1, 23, 59, 59)
      //this.tradeDate.push(date1)

      //前一天设定的日期时间
      let year2, month2, day2
      d.setTime(d.getTime() - 7 * 24 * 60 * 60 * 1000);
      [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()]
      let date2 = new Date(year2, month2, day2, 0)
      //this.tradeDate.unshift(date2)
      this.tradeDate.push(datefmt.dateFormat("yyyy-MM-dd HH:mm:ss", date2))
      this.tradeDate.push(datefmt.dateFormat("yyyy-MM-dd HH:mm:ss", date1))
    }
  }
</script>

<style >
  a{
    color: #409EFF;
    text-decoration: none;
  }

</style>




// WEBPACK FOOTER //
// src/custom/ItmFull.vue